<template>
  <div>
    <!--<b>{{item.userID}}</b>-->
    <span>{{ item.desigName }}</span>
    <!-- <abbr>{{item.userName}}</abbr> -->
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/usercontrols/DesignationSearchTemplate.vue